/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Source_ManualInputs */

const en_source_manual = /** @type {(inputs: Source_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Own recipe`)
};

const de_source_manual = /** @type {(inputs: Source_ManualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eigenes Rezept`)
};

/**
* | output |
* | --- |
* | "Own recipe" |
*
* @param {Source_ManualInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const source_manual = /** @type {((inputs?: Source_ManualInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Source_ManualInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_source_manual(inputs)
	return en_source_manual(inputs)
});